export const getSingleActivityFetching = state => state?.activities?.singleFetching;

export const getSingleActivityData = (state, iri) => state?.activities?.[iri] || {};

export const getIsDuplicateActivityInProgress = state =>
    state?.activities?.isDuplicateActivityInProgress || false;
